import { Activity, useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Close as CloseIcon } from '@mint-lib/icons';
import { Button, typographyVariants } from '@mint-lib/tw-components';
//TODO: Remove @mint-lib/theme/src/extensions/palette after migration to new Drawer
import '@mint-lib/theme/src/extensions/palette';
import { Chat } from '@mint-sdk/api-ai-assistant';

import { Drawer } from '@myn/mui';

import { ProcessDetailsView } from '../ui/ProcessDetailsView.jsx';

type Props = {
  reasoningData: Chat.AiChatMessageRecordType[];
  webSources: string[];
  knowledgeBaseSources: string[];
};

const ReasoningSummaryDrawer = ({
  reasoningData,
  knowledgeBaseSources,
  webSources,
}: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  const [isOpen, setIsOpen] = useState(false);

  const isDrawerVisible =
    reasoningData.length || knowledgeBaseSources.length || webSources.length;

  return (
    <>
      <Activity mode={isDrawerVisible ? 'visible' : 'hidden'}>
        <Button variant="plain" onClick={() => setIsOpen(!isOpen)}>
          {t('Show process details')}
        </Button>
      </Activity>

      {/*TODO: Replace with new Drawer from tw-component when it is possible to make the window appear at the bottom of the screen */}
      <Drawer
        sx={{
          '& .MuiDrawer-paper': {
            backgroundColor: (theme) => theme.palette.ui.primary,
            paddingX: 1,
            paddingY: 0,
            height: `60dvh`,
            borderRadius: '20px 20px 0 0 ',
            backgroundImage: 'none',
          },
        }}
        anchor="bottom"
        open={isOpen}
        variant="temporary"
        onClose={() => setIsOpen(false)}
      >
        <div className="sticky top-0 z-focus mb-2 flex items-center gap-3 bg-ui-primary px-2 py-3">
          <Button
            variant="plain"
            icon
            size="small"
            onClick={() => setIsOpen(false)}
          >
            <CloseIcon />
          </Button>
          <p
            className={typographyVariants({
              variant: 'h4',
              color: 'primary',
            })}
          >
            {t('Process details')}
          </p>
        </div>

        <ProcessDetailsView
          reasoningData={reasoningData}
          webSources={webSources}
          knowledgeBaseSources={knowledgeBaseSources}
        />
      </Drawer>
    </>
  );
};

export { ReasoningSummaryDrawer };
